<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  iconKey: {
    type: String,
    required: true,
  },
  connected: {
    type: Boolean,
    default: false,
  },
  inactive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  if (props.inactive) return;
  emit('click');
};
</script>

<template>
  <button
    type="button"
    :data-testid="`channel_card_${iconKey}`"
    class="flex flex-col items-center gap-2 p-4 border rounded-lg text-center transition-colors"
    :class="{
      'border-green-300 bg-green-25 dark:bg-green-900/20':
        connected && !inactive,
      'border-slate-100 dark:border-slate-700 hover:border-woot-500':
        !connected && !inactive,
      'border-slate-100 dark:border-slate-800 cursor-not-allowed': inactive,
    }"
    @click="handleClick"
  >
    <div class="relative">
      <img
        :src="`/assets/images/dashboard/channels/${iconKey}.png`"
        :alt="name"
        class="h-10 w-10"
        :class="{ 'grayscale opacity-60': inactive }"
      />
      <span
        v-if="connected && !inactive"
        class="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-green-500 flex items-center justify-center"
      >
        <fluent-icon icon="checkmark" size="10" class="text-white" />
      </span>
    </div>
    <span
      class="text-sm font-medium"
      :class="
        inactive
          ? 'text-slate-400 dark:text-slate-500'
          : 'text-slate-700 dark:text-slate-200'
      "
    >
      {{ name }}
    </span>
  </button>
</template>
